import BarcodeLabel from "./BarcodeLabel";

export default BarcodeLabel;
